import { Style } from 'index';

const ProjectPageStyles: Style = {
    tab: {
        fontSize: '1.25rem',
        whiteSpace: 'nowrap',
        ':hover': { color: 'secondary.main' },
    },
    stepper: {
        '.MuiStepConnector-root': {
            marginLeft: '20px',
        },
    },
};

export default ProjectPageStyles;
